import Vue from 'vue'
import {investments_api} from '@/store/resources'
import {dealTypes} from "@/utilities/invest_deal_types"

export default {
    namespaced: true,
    state: {
        filters: {
            ticker: null,
            date: {
                start: 1,
                end: 1
            },
            event_type: {
                buy: {
                    checked: true,
                    value: dealTypes.TYPE_BUY,
                    label_en: 'Buy',
                    label_ru: 'Покупка'
                },
                sell: {
                    checked: true,
                    value: dealTypes.TYPE_SELL,
                    label_en: 'Sell',
                    label_ru: 'Продажа'
                },
                dividend: {
                    checked: true,
                    value: dealTypes.TYPE_INCOME_DIVIDEND,
                    label_en: 'Dividend',
                    label_ru: 'Дивиденд'
                },
                coupon: {
                    checked: true,
                    value: dealTypes.TYPE_INCOME_COUPON,
                    label_en: 'Coupon',
                    label_ru: 'Купон'
                },
                amortization: {
                    checked: true,
                    value: dealTypes.TYPE_INCOME_AMORTIZATION,
                    label_en: 'Amortization',
                    label_ru: 'Амортизация'
                },
                deposit: {
                    checked: true,
                    value: dealTypes.TYPE_DEPOSITING,
                    label_en: 'Deposit',
                    label_ru: 'Внесение'
                },
                withdraw: {
                    checked: true,
                    value: dealTypes.TYPE_WITHDRAWAL,
                    label_en: 'Withdraw',
                    label_ru: 'Вывод'
                },
                commission: {
                    checked: true,
                    value: dealTypes.TYPE_EXPENSE_COMMISSION,
                    label_en: 'Commission',
                    label_ru: 'Комиссия'
                },
                tax: {
                    checked: true,
                    value: dealTypes.TYPE_EXPENSE_TAX,
                    label_en: 'Tax',
                    label_ru: 'Налог'
                },
            },
            instrument_type: {title_en: 'All', title_ru: 'Все', id: 0},
            pagination: {
                current_page: 1,
                pages: null
            }
        },
        deals: {
            data: [],
            dirty: true
        },
    },
    actions: {
        createDeal: ({}, data) => investments_api.deals.save(data),
        updateDeal: ({}, data) => investments_api.deals.update({id: data.id}, {...data}),
        async fetchDealsHistory({commit, state, rootState}) {
            const filters = {
                portfolio_id: rootState.investments.portfolios.current_portfolio.data.id,
                date_start: Vue.prototype.$moment(state.filters.date.start, 'YYYY-MM-DD').unix(),
                date_end: Vue.prototype.$moment(state.filters.date.end, 'YYYY-MM-DD').endOf('day').unix(),
                page: state.filters.pagination.current_page,
                type: Object.keys(state.filters.event_type)
                    .map(item => state.filters.event_type[item].checked && state.filters.event_type[item].value),
                instrument_type: state.filters.instrument_type.value === 0 ? [] : state.filters.instrument_type.value,
                ticker: state.filters.ticker
            }
            const res = await investments_api.deals.get(filters)
            if (res.body.success) {
                commit('setDealsData', res.body)
            }
        }
    },
    mutations: {
        setDealsData(state, body) {
            state.deals.data = body.data.rows;
            state.deals.dirty = false;
            state.filters.pagination.pages = Math.ceil(body.data.length / 20);
        },
        setDealNote(state, data) {
            let deals = [...state.deals.data];
            deals = deals.map(item => {
                if (item.id === data.id) {
                    return {...item, note: data.note}
                } else {
                    return item
                }
            });
            state.deals.data = deals
        },
        setFilter(state, payload) {
            state.filters[payload.name] = payload.value;
            state.filters.pagination.current_page = 1;
        },
        toggleEventFilter(state, name) {
            state.filters.event_type[name].checked = !state.filters.event_type[name].checked;
            state.filters.pagination.current_page = 1;
        },
        setPage(state, num) {
            state.filters.pagination.current_page = num;
        },
        resetPagination(state) {
            state.filters.pagination = {current_page: 1, pages: null};
        },
    }
}